import { InheritanceStatus, Slug } from '../../Quests/Quest.Interfaces'

export enum SMSGroupType {
  SCHEDULED = 'scheduled',
  INTERVAL = 'interval'
}

export interface WithinRangeInterface {
  startMinute: number
  endMinute: number
  timeZone: string
}

export interface SMSGroup {
  id: string
  name: string
  botId: string
  slug?: Slug
  createdAt: Date
  type: SMSGroupType
  timeIntervalInMinutes?: number
  active: boolean
  questSlug?: string // Only used in Interval Groups
  questId?: string // Deprecated
  membersCount: number
  withinRange?: WithinRangeInterface
  isTest?: boolean
  inheritance?: InheritanceStatus
}

export interface SMSGroupMember {
  id: string
  botId: string
  createdAt: Date
  phoneNumber: string
  groupId?: string // This is going to be deprecated once quest 2.0 is released
  groupSlug?: Slug
  active: boolean
}

export interface SMSScheduledMessage {
  id: string
  botId: string
  name: string
  createdAt: Date
  type: SMSGroupType
  groupId?: string
  groupSlug?: Slug

  group: SMSGroup
  memberId?: string // Only used in cased of type interval
  questSlug?: string
  questId?: string // Deprecated
  scheduledFor: Date
  sent: boolean
  sentAt?: Date
  isTest?: boolean
}

export interface SMSOptOut {
  id: string
  botId: string
  createdAt: Date
  phoneNumber: string
  optOut: boolean
}
